import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.treasureHuntLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.treasureHuntLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.treasureHuntLevels.data.treasureHuntLevels,
  (levels = []) => levels
);
const getGroupOrderNumber = createSelector(
  (state) => state.treasureHuntLevels.data.treasureHuntGroupOrderNumber,
  (groupOrderNumber = 1) => groupOrderNumber
);

export default {
  getCurrencyData,
  getGroupOrderNumber,
  getHasLoaded,
  getLevelsData,
};
